import React, { Component } from 'react';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import withScrollToTop from 'client/helpers/withScrollToTop';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_PMS_SYNC } from 'client/constants/screenIds';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrPartnerSection from 'client/components/SrPartnerSection';
import UPAdminPendingGmailAttachmentMappingsDataTable from 'client/components/UPAdminPendingGmailAttachmentMappingsDataTable/UPAdminPendingGmailAttachmentMappingsDataTable';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_PMS_SYNC)
@withScrollToTop
@branch({
  utilityDealers: ['utilityDealers', 'list'],
  utilitySalesReps: ['utilitySalesReps', 'list'],
})
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  redirectUrl: '/',
})
class UtilityProfitAdminPmsProcessingToolPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'PMS Processing Tool | Utility Profit',
  });

  render() {
    return (
      <SrPartnerPageV2
        navbarTitle="Utility Profit Admin"
        navbarImage="/images/utility-profit-logo.svg"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
        maxWidth="100%"
      >
        <SrPartnerSection
          title="Unassigned Property Management Files"
          padding="20px"
          titleWeight="700"
        >
          <UPAdminPendingGmailAttachmentMappingsDataTable />
        </SrPartnerSection>
      </SrPartnerPageV2>
    );
  }
}

export default UtilityProfitAdminPmsProcessingToolPage;
